import React, { useState } from 'react'
import './checkbox.less'

export default ({ onChange, checked }: any) => {
  const [check, setCheck] = useState()
  if (check !== checked) {
    setCheck(checked)
  }

  return (
    <label>
      <div className="checkcircle">
        <input
          onChange={({ target }: any) => {
            if (onChange) {
              onChange(target.checked)
            }
          }}
          type="checkbox"
          checked={check}
        />
        <div className="show-box" />
      </div>
    </label>
  )
}
